import type { ReactNode } from 'react';

import { MixedState } from './MixedState';
import { SingleState } from './SingleState';

interface BomStateInfoProps {
    state:
        | 'draft'
        | 'invalid'
        | 'missingBom'
        | 'mixed'
        | 'processing'
        | 'valid';
    validCount?: number;
    invalidCount?: number;
    missingCount?: number;
}

export const BomStateInfo = ({
    state,
    validCount,
    invalidCount,
    missingCount,
}: BomStateInfoProps): ReactNode => {
    if (state === 'mixed') {
        return (
            <MixedState
                validCount={validCount ?? 0}
                invalidCount={invalidCount ?? 0}
                missingCount={missingCount ?? 0}
            />
        );
    }
    if (state === 'processing') return <SingleState type="processing" />;
    if (state === 'draft') return <SingleState type="draft" />;
    if (state === 'invalid') return <SingleState type="invalid" />;
    if (state === 'valid') return <SingleState type="valid" />;
    return <SingleState type="missing bom" />;
};
